import all from "./all";
const state = {
  namespaced: true,
  state: {},
  actions: {},
  modules: {
    all,
  },
};

export default state;
